import type { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";
import { DEFAULT_VIEW_INDEX } from "modules/common/model/viewTypes";

export const VIEW_PREFERENCE_COOKIE = "lootstack-view-preference";

function parseViewCookie(value: string | undefined): 0 | 1 {
  if (value === "1") return 1;
  if (value === "0") return 0;
  return DEFAULT_VIEW_INDEX;
}

/**
 * Reads the view preference cookie server-side.
 * Returns 0 (Table) or 1 (Visual); DEFAULT_VIEW_INDEX when no cookie is set.
 */
export function getViewPreferenceFromCookies(
  cookieStore: ReadonlyRequestCookies
): 0 | 1 {
  return parseViewCookie(cookieStore.get(VIEW_PREFERENCE_COOKIE)?.value);
}

/**
 * Sets the view preference cookie. Browser-only — call from client actions
 * and effects (e.g. alongside a Zustand setViewPreference update).
 */
export function setViewPreferenceCookie(view: 0 | 1): void {
  document.cookie = `${VIEW_PREFERENCE_COOKIE}=${view}; path=/; max-age=31536000; SameSite=Lax`;
}

/**
 * Returns true if the view preference cookie is present. Browser-only.
 */
export function hasViewPreferenceCookie(): boolean {
  return document.cookie.includes(`${VIEW_PREFERENCE_COOKIE}=`);
}
